export default __webpack_public_path__ + "0c5ea6508868bcf35cf6215552136dcd.svg";